import { formatDuration } from 'src/utils/stringUtils';

export const Duration = ({ value }: { value: number }) => {
    return <>{formatDuration(value)}</>;
};
